import { render, staticRenderFns } from "./InstallationsLegend.vue?vue&type=template&id=7a8bb3eb&"
import script from "./InstallationsLegend.vue?vue&type=script&lang=ts&"
export * from "./InstallationsLegend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
